<div class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <span>
        <h1 class="screen-title">{{ screentitle }}</h1>
      </span>
    </div>
    <div class="card-body" >
      <div class="row">
        <div class="col-md-4 col-md-offset-4">
          <div class="form-group" style="margin-top: 15px;">
            <label for="file">Select File to Upload :</label>
            <input type="file" class="form-control" id="file" accept=".csv" [(ngModel)]="selectedFile" (change)='fileChangeListener($event)'>
          </div>
          <div class="form-group" style="display:flex;justify-content: center;" *ngIf="!loader">
            <button class="btn btn-primary commonbutt" (click)="downloadSampleFile()">
              <em class="fa fa-download"></em>&nbsp;&nbsp;
              <span class="bold">Download Credit Shell Sample</span>
            </button>
            <button class="btn btn-primary commonbutt" (click)="downloadSampleFileDC()">
              <em class="fa fa-download"></em>&nbsp;&nbsp;
              <span class="bold">Download Date Change Sample</span>
            </button>
            <button class="btn btn-success commonbutt" type="button" (click)='uploadFile()'>
              <em class="fa fa-upload"></em>&nbsp;&nbsp;
              <span class="bold">Upload</span>
            </button>
          </div>
          <div id="upload_err_div" class="form-group has-error has-feedback" style="text-align: center;">
            <!-- has-success -->
            <label class="control-label" for="inputError">{{upload_err}}</label>
          </div>
          
        </div>
      </div>
    </div>
    <div *ngIf="loader">
      <div style="margin:auto; text-align: center">
        <img
          src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
          width="8%"
          height="8%"
          alt="Loader"
        />
      </div>
  </div>
</div>